import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=6b89a88e&"
import script from "./Contests.vue?vue&type=script&lang=ts&"
export * from "./Contests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports